module.exports = __webpack_public_path__ + "img/Lithuania.5805eb6a.gif";